import React, { useState, useRef } from 'react'
import { resendOtp, verifyOtp } from '../../services/OtpServices'
import { useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'

const OtpVerification = ({ userNumber, sessionId: initialSessionId }) => {
  console.log('sessionId in OtpVerification--->', initialSessionId, userNumber)

  const OTP_LENGTH = 6
  const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(''))
  const [sessionId, setSessionId] = useState(initialSessionId)
  const inputRefs = useRef([]) // Ref to hold references of input fields
  const navigate = useNavigate('')

  const handleChange = (index, event) => {
    const newOtp = [...otp]
    newOtp[index] = event.target.value

    // Allow only 1 digit per input
    if (event.target.value.length > 1) {
      newOtp[index] = event.target.value.slice(0, 1)
    }

    setOtp(newOtp)

    // Move focus forward
    if (event.target.value !== '' && index < OTP_LENGTH - 1) {
      inputRefs.current[index + 1].focus()
    }
  }

  const Otpresend = async () => {
    const res = await resendOtp({ mobile: userNumber })
    if (res?.status === 'success') {
      setSessionId(res.data.sessionId) // update with new sessionId
      toast.success('OTP resent successfully')
      setOtp(Array(OTP_LENGTH).fill(''))
      inputRefs.current[0].focus()
    } else {
      toast.error('Failed to resend OTP')
    }
  }

  const optVerification = async () => {
    const otpString = otp.join('')
    if (otpString.length !== OTP_LENGTH) {
      toast.error(`Please enter all ${OTP_LENGTH} digits`)
      return
    }
    await verifyOtp(userNumber, otpString, sessionId).then(res => {
      if (res.status === 'success') {
        if (res.data.newUser) {
          navigate('/signup')
        } else {
          localStorage.setItem('token', res.token)
          const lastPath = localStorage.getItem('path')
          if (lastPath) {
            localStorage.removeItem('path')
            navigate(lastPath)
          } else {
            navigate('/')
          }
        }
      } else {
        toast.error('Invalid OTP')
      }
    })
  }

  // Function to handle backspace press
  const handleBackspace = (index, event) => {
    if (event.keyCode === 8 && index > 0 && otp[index] === '') {
      inputRefs.current[index - 1].focus()
    }
  }

  return (
    <>
      {/* <ToastContainer /> */}
      <div>
        <div className='text-center'>
          <div className='d-flex justify-content-center gap_2 custom_otp_group'>
            {otp.map((value, index) => (
              <input
                key={index}
                ref={el => (inputRefs.current[index] = el)} // Store input reference
                className={`custom_otp_input fs_41 ff_inter fw-bold px-2 ${
                  value === '' && 'border-green-2'
                }`}
                type='number'
                maxLength={1} // Allow only single character input
                value={value}
                onChange={event => handleChange(index, event)}
                onKeyDown={event => handleBackspace(index, event)}
              />
            ))}
          </div>
          <div className='row'>
            <div className='col-6'></div>
            <div className='col-6'>
              <p
                onClick={Otpresend}
                className='fs_12 ff_inter fw-normal color_gray my-2 text-end mt-3'
              >
                <span className='cursor_pointer border-green-1 clr_dark_green'>
                  Resend OTP
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className='text-center'>
        <button
          style={{ height: '40px', lineHeight: '0' }}
          onClick={optVerification}
          className='bg_dark_green clr_white fs_2xsm ff_heebo custom_green_button'
          type='submit'
        >
          VERIFY OTP
        </button>
      </div>
    </>
  )
}

export default OtpVerification
